import { render } from "./Roll.vue?vue&type=template&id=c7cad548"
import script from "./Roll.vue?vue&type=script&lang=js"
export * from "./Roll.vue?vue&type=script&lang=js"

import "./Roll.vue?vue&type=style&index=0&id=c7cad548&lang=css"
script.render = render

export default script